<template>
  <!-- Directory Filter (and other actions) -->
  <div class="px-6 pt-2 pb-4">
    <div class="flex flex-col">
      <h2 @click="loadCoaches" class="text-lg font-bold text-gray-900 mb-1 mt-1">Coach Directory (<strong class="text-green-600">{{ totalCoaches }}</strong>)</h2>
      <em class="text-gray-600 text-xs mb-4">You can filter the coaches by Areas of Expertise. <br/> Click on the profile to see Coach's Profile/Details and message them. </em>
    </div>
    <FilterCoaches @change-filter="setFilters"></FilterCoaches>
  </div>
  <!-- Directory list -->
  <nav class="flex-1 min-h-0 overflow-y-auto coachMenu" aria-label="Directory">
    <div class="relative">
      <!-- todo spinner -->
      <BaseSpinner v-if="isLoading"></BaseSpinner>

      <ul v-else-if="hasCoaches" class="relative z-0 divide-y divide-gray-200 border-t border-b border-gray-200">
        <CoachItem v-for="person in filteredCoaches"
                   :key="person.id"
                   :coachId="person.id"
                   :firstName="person.firstName"
                   :lastName="person.lastName"
                   :picUrl="person.pic"
                   :areas="person.areas"
                   :rate="person.hourlyRate"
        >
        </CoachItem>
      </ul>
      <div v-else-if="error">
        <div class="bg-red-300 rounded px-3 pt-1 pb-1">
          {{ error }}</div>
      </div>
      <div v-else class="px-6 pt-2 pb-4">
        <h3>No coaches yet. </h3>
      </div>

    </div>
  </nav>
</template>

<script>
import CoachItem from "./CoachItem";
import FilterCoaches from "./FilterCoaches";
import BaseSpinner from "../../../UI/BaseSpinner";

export default {
  components: {
    FilterCoaches,
    CoachItem,
    BaseSpinner,
  },
  data(){
    return{
      activeFilters: {
        frontend: true,
        backend: true,
        career: true
      },
      isLoading: false,
      error: null,
    };
  },
  computed: {
    totalCoaches(){
      return this.$store.getters['coaches/coaches'].length;
    },
    filteredCoaches(){
      //BEFORE FILTERS return this.$store.getters['coaches/coaches']; //todo remember these modules are now namespaced!!!
      const coaches = this.$store.getters['coaches/coaches']; //todo remember these modules are now namespaced!!!
      return coaches.filter(coach => {
          if (this.activeFilters.frontend && coach.areas.includes('frontend')) {
            return true;
          }
          if (this.activeFilters.backend && coach.areas.includes('backend')) {
            return true;
          }
          if (this.activeFilters.career && coach.areas.includes('career')) {
            return true;
          }
        }
      );
    },
    hasCoaches(){
      return this.$store.getters['coaches/hasCoaches'];
    },
  },
  methods: {
    setFilters(updatedFilters){ //todo look in FilterCoaches (this.$emit('change-filter', updatedFilters);)
      this.activeFilters = updatedFilters;
    },
    async loadCoaches(){
      this.isLoading = true;
      try {
        await this.$store.dispatch('coaches/loadCoaches');
        // .catch(error => {
        //   console.log(error);
        //     this.error = 'Failed to load list of coaches.';
        // });
      }
      catch(error){
        this.error = error.message || 'Failed to load list of coaches';
      }
      this.isLoading = false;
    },
  },
  created() {
    this.loadCoaches();
    //console.log(this.$store.state.coaches);
  },
  mounted() {
  }
}
</script>